module.exports = __webpack_public_path__ + "media/images/soar/site/bg_footer-414dbe06b9c2e205c44f2ee9cceb4fe6.svg";